import { render, staticRenderFns } from "./AvitoAreaAdd.vue?vue&type=template&id=6b80ca7b&"
import script from "./AvitoAreaAdd.vue?vue&type=script&lang=js&"
export * from "./AvitoAreaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports